<template>
  <div class="left-wrap">
    <div class="left-content productSales">
      <div class="bgColor"></div>
      <div class="title">产品销量</div>
      <a-tabs default-active-key="1" v-model="activeKey">
        <a-tab-pane key="1" tab="当日" style="overflow-y: auto">
          <div class="cardList">
            <div class="shuliao cardItem">
              <label class="name">熟料</label>
              <img src="../../assets/picture/left/clinker_icon.png" alt="" />
              <label class="num"
                >{{ productSalesvolume.daySl
                }}<span class="unit">吨</span></label
              >
            </div>
            <div class="shuini cardItem">
              <label class="name">水泥</label>
              <img src="../../assets/picture/left/cement.png" alt="" />
              <label class="num"
                >{{ productSalesvolume.daySn
                }}<span class="unit">吨</span></label
              >
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="当月" force-render>
          <div class="cardList">
            <div class="shuliao cardItem">
              <label class="name">熟料</label>
              <img src="../../assets/picture/left/clinker_icon.png" alt="" />
              <label class="num"
                >{{ productSalesvolume.monthSl
                }}<span class="unit">吨</span></label
              >
            </div>
            <div class="shuini cardItem">
              <label class="name">水泥</label>
              <img src="../../assets/picture/left/cement.png" alt="" />
              <label class="num"
                >{{ productSalesvolume.monthSn
                }}<span class="unit">吨</span></label
              >
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="left-content outputData" style="margin: 1rem 0">
      <div class="bgColor"></div>
      <div class="title">产品产量</div>
      <a-tabs default-active-key="1" v-model="activeKey">
        <a-tab-pane key="1" tab="当日" style="overflow-y: auto">
          <div class="cardList">
            <div class="shuliao cardItem">
              <label class="dangricl">产量</label>
              <label class="danwei">(吨)</label>
              <label class="nums">{{ productOutput.daySL }}</label>
              <label class="names">熟料</label>
            </div>
            <div class="shuini cardItem">
              <label class="dangricl">产量</label>
              <label class="danwei">(吨)</label>
              <label class="nums">{{ productOutput.daySN }}</label>
              <label class="names">水泥</label>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="当月" force-render>
          <div class="cardList">
            <div class="shuliao cardItem">
              <label class="dangricl">产量</label>
              <label class="danwei">(吨)</label>
              <label class="nums">{{ productOutput.monthSL }}</label>
              <label class="names">熟料</label>
            </div>
            <div class="shuini cardItem">
              <label class="dangricl">产量</label>
              <label class="danwei">(吨)</label>
              <label class="nums">{{ productOutput.monthSN }}</label>
              <label class="names">水泥</label>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="left-content productInventory">
      <div class="bgColor"></div>
      <div class="title">产品库存</div>
      <a-row :gutter="0" style="padding-top: 4rem; height: calc(100% - 3rem)">
        <a-col :span="8" class="title1">
          <div class="toptext">
            <i class="smalliconleft"></i><i class="lefticon"></i>
            <label class="texts">生料</label>
          </div>
          <div class="botnum">
            <span class="numsty">{{ kucun.YL }}</span
            >&nbsp;t
          </div>
          <div class="chart-box">
            <div class="liquidFill" ref="liquidFill"></div>
          </div>
        </a-col>
        <a-col :span="8" class="title1">
          <div class="toptext">
            <i class="smalliconleft"></i><i class="lefticon"></i>
            <label class="texts">熟料</label>
          </div>
          <div class="botnum">
            <span class="numsty">{{ kucun.SL }}</span
            >&nbsp;t
          </div>
          <div class="chart-box">
            <div class="liquidFill" ref="liquidFill1"></div>
          </div>
        </a-col>
        <a-col :span="8" class="title1">
          <div class="toptext">
            <i class="smalliconleft"></i><i class="lefticon"></i>
            <label class="texts">水泥</label>
          </div>
          <div class="botnum">
            <span class="numsty">{{ kucun.SN }}</span
            >&nbsp;t
          </div>
          <div class="chart-box">
            <div class="liquidFill" ref="liquidFill2"></div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { number } from "echarts";
import httpUrl from "../../views/httpUrl";
export default {
  data() {
    return {
      chartData2: null,
      activeKey: "1",
      tabs: null,
      productSalesvolume: {
        daySl: "",
        daySn: "",
        monthSl: "",
        monthSn: "",
      }, //产品销量
      productOutput: {}, //产品产量
      kucun: {},
      timeOut: null,
    };
  },
  created() {
    var _this = this;
    _this.tabs = setInterval(function () {
      _this.activeKey = _this.activeKey == "1" ? "2" : "1";
    }, 5000);
  },
  beforeDestroy() {
    if (this.tabs) {
      clearInterval(this.tabs);
    }
  },
  mounted() {
    let _this = this;
    _this.getSaleByDayAndMonth();
    _this.getQuantity();
    _this.getProductSum();

    _this.timeOut = setInterval(function () {
      _this.getSaleByDayAndMonth();
      _this.getQuantity();
      _this.getProductSum();
    }, 1800000);
  },
  destroyed() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
  },
  methods: {
    //当日和当月销量
    getSaleByDayAndMonth() {
      this.$myHttp
        .get(httpUrl.home.getSaleByDayAndMonth)
        .then((res) => {
          this.productSalesvolume.daySl =
            res.data.day[0] ? res.data.day[0].value : "";
          this.productSalesvolume.daySn =
            res.data.day[0] ? res.data.day[1].value : "";
          this.productSalesvolume.monthSl =
            res.data.month[0] ? res.data.month[0].value : "";
          this.productSalesvolume.monthSn =
            res.data.month[0] ? res.data.month[1].value : "";
        })
        .catch((res) => {});
    },
    //当日和当月产量
    getProductSum() {
      this.$myHttp
        .get(httpUrl.home.productSum)
        .then((res) => {
          this.productOutput = {
            daySN: res.data.daySN,
            daySL: res.data.daySL,
            monthSL: res.data.monthSL,
            monthSN: res.data.monthSN,
          };
        })
        .catch((res) => {});
    },
    //库存和仓库容量
    getQuantity() {
      this.$myHttp
        .get(httpUrl.home.getQuantity)
        .then((res) => {
          if (res.code == "200") {
            this.kucun = {
              YL: res.data.YL,
              YLPct: Number((res.data.YL / res.data.YLQ).toFixed(2)),
              SL: res.data.SL,
              SLPct: Number((res.data.SL / res.data.SLQ).toFixed(2)),
              SN: res.data.SN,
              SNPct: Number((res.data.SN / res.data.SNQ).toFixed(2)),
            };
            this.drawChart();
            this.drawChart1();
            this.drawChart2();
          }
        })
        .catch((res) => {});
    },
    drawChart() {
      const chart = this.$echarts.init(this.$refs.liquidFill);
      const dataOption = {
        value: this.kucun.YLPct,
        itemStyle: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(128, 255, 165)",
            },
            {
              offset: 1,
              color: "#21CD7EFF",
            },
          ]),
        },
      };
      const option = {
        series: [
          {
            type: "liquidFill",
            shape: "rect",
            radius: 200,
            amplitude: "8%", // 振幅
            data: [dataOption, dataOption],
            backgroundStyle: {
              color: "#112D60FF",
            },
            outline: {
              show: false,
            },
            label: {
              normal: {
                show: true,
                position: ["50%", 70],
                textStyle: {
                  fontSize: 20,
                  color: "white",
                },
                formatter: function (obj) {
                  let { value } = obj;
                  let num = parseInt(value * 100).toString();
                  return `${num}\n(%)`;
                },
              },
            },
          },
        ],
      };
      chart.setOption(option);
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },
    drawChart1() {
      const chart = this.$echarts.init(this.$refs.liquidFill1);
      const dataOption = {
        value: this.kucun.SLPct,
        itemStyle: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "#25ADFFFF",
            },
            {
              offset: 1,
              color: "#00498069",
            },
          ]),
        },
      };
      const option = {
        series: [
          {
            type: "liquidFill",
            shape: "rect",
            radius: 200,
            amplitude: "8%", // 振幅
            data: [dataOption, dataOption],
            backgroundStyle: {
              color: "#112D60FF",
            },
            outline: {
              show: false,
            },
            label: {
              normal: {
                show: true,
                position: ["50%", 70],
                textStyle: {
                  fontSize: 20,
                  color: "white",
                },
                formatter: function (obj) {
                  let { value } = obj;
                  let num = parseInt(value * 100).toString();
                  return `${num}\n(%)`;
                },
              },
            },
          },
        ],
      };
      chart.setOption(option);
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },
    drawChart2() {
      const chart = this.$echarts.init(this.$refs.liquidFill2);
      const dataOption = {
        value: this.kucun.SNPct,
        itemStyle: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "#FFB220FF",
            },
            {
              offset: 1,
              color: "#9C650099",
            },
          ]),
        },
      };
      const option = {
        series: [
          {
            type: "liquidFill",
            shape: "rect",
            radius: 200,
            amplitude: "8%", // 振幅
            data: [dataOption, dataOption],
            backgroundStyle: {
              color: "#112D60FF",
            },
            outline: {
              show: false,
            },
            label: {
              normal: {
                show: true,
                position: ["50%", 70],
                textStyle: {
                  fontSize: 20,
                  color: "white",
                },
                formatter: function (obj) {
                  let { value } = obj;
                  let num = parseInt(value * 100).toString();
                  return `${num}\n(%)`;
                },
              },
            },
          },
        ],
      };
      chart.setOption(option);
      window.addEventListener("resize", function () {
        chart.resize();
      });
    },
  },
};
</script>

<style lang="less">
.left-wrap {
  overflow: hidden;
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  .left-content {
    flex: 1;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    border: 1px #0054ff solid;
    .bgColor {
      width: 96%;
      position: absolute;
      background: hsl(220, 100%, 50%);
      opacity: 0.3;
      line-height: 2.8rem;
      height: 2.8rem;
    }
    .title {
      color: white !important;
      position: absolute;
      line-height: 3rem;
      font-size: 1.1rem;
      width: 96%;
      padding-left: 1rem;
    }
    .cardList {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin-top: 3rem;
      .cardItem {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        label {
          color: #fff;
          margin: 0;
        }
        // 产品销量
        .name {
          font-size: 1.2rem;
        }
        .num {
          font-size: 2rem;
          font-weight: bold;
          margin-top: 0.5rem;
          .unit {
            font-size: 1.2rem;
          }
        }
        img {
          display: inline-block;
          width: 6rem;
          height: 6rem;
        }
        // 产品数据
        .dangricl {
          font-size: 0.8rem;
          margin-top: 1rem;
        }
        .danwei {
          font-size: 0.8rem;
          margin-top: 0.1rem;
        }
        .nums {
          font-size: 1.3rem;
          font-weight: bold;
        }
        .names {
          font-size: 1.2rem;
        }
      }
    }
  }
}

.productSales,
.outputData,
.productInventory {
  width: 100%;
  height: 100%;
  position: relative;
}
.productSales,
.productInventory {
  padding: 0.5rem 0.5rem 0 0.5rem;
}
.outputData {
  padding: 0.5rem 0.5rem 0 0.5rem;
  .cardList {
    margin-top: 3rem;
    .cardItem {
      position: relative;
      height: 8rem;
      width: 8rem;
      background: url("../../assets/picture/left/clinker_output.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
.productInventory {
  .smallicon1 {
    color: #22cd7e;
    margin-left: 0rem;
    margin-right: 0.5rem;
  }

  .smallicon2 {
    color: #25adff;
    font-size: 1.5rem;
  }

  .title1 {
    color: white;
    font-size: 1.5rem;
    text-align: center;
    height: 100%;
  }

  .numsty {
    font-size: 1.2rem;
  }

  .botnum {
    margin-top: 2.5rem;
    color: #afc9ff;
  }

  .smalliconleft {
    width: 0.13rem;
    height: 1.5rem;
    background: #25adff;
    float: left;
    margin-top: 0.6rem;
  }
  .texts {
    font-size: 1rem;
  }
  .toptext {
    float: left;
    margin-left: calc(50% - 1.5rem);
  }

  .lefticon {
    width: 1.07rem;
    height: 1.44rem;
    background: linear-gradient(90deg, #25adff 0%, rgba(37, 173, 255, 0) 100%);
    opacity: 0.5;
    margin-left: 0.2rem;
    float: left;
    margin-top: 0.6rem;
  }

  .chart-box {
    width: 5rem;
    height: calc(100% - 3rem);
    position: relative;
    left: calc(50% - 2.5rem);
  }

  .liquidFill {
    width: 100%;
    height: 100%;
  }
}
.ant-tabs {
  height: 100%;
}
.ant-tabs-nav-wrap {
  display: inline-block;
  float: right;
}
.ant-tabs-bar {
  border-bottom: none !important;
}
.ant-tabs-nav .ant-tabs-tab-active {
  background-image: linear-gradient(
    #00000000,
    rgba(141, 194, 197, 0.5)
  ) !important;
}
.ant-tabs-nav .ant-tabs-tab-active {
  color: #fff !important;
  font-weight: bold;
}
.ant-tabs-nav .ant-tabs-tab {
  color: #fff;
  margin: 0 !important;
}
.ant-tabs-nav-container {
  /* background:#0054FF ;
  opacity: .3; */
}
</style>


// WEBPACK FOOTER //
// src/components/home/leftPart.vue